import {
  browserFastApiClient,
  requireFastApiAccessToken,
} from "@/core/fastapi";
import {
  setReflectionApiService,
  type SetReflectionRequest,
} from "@/generated/fastapi";

export async function setReflection(
  accessToken: string | null | undefined,
  request: SetReflectionRequest,
) {
  const response = await setReflectionApiService({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
    body: request,
  });

  if (response.status !== 200) {
    throw new Error(`Failed to set reflection (${response.status})`);
  }

  return response.data ?? null;
}
